<template>
  <div class="post-message">
    <div class="head-nav c-s" v-if="loginStatus == 1">
      <div class="left-aaaa" @click="cat()">
        <!-- <van-icon name="arrow-left"/> -->
        <img src="../assets/images/images/left_qq.png" alt />
      </div>
      <div class="title f12">
        {{ topWord }}
      </div>
      <div class="login c-c f14" @click="login()">登录</div>
    </div>
    <div class="head-nav c-s" v-if="loginStatus !== 1">
      <div class="left-aaaa" @click="cat2()">
        <!-- <van-icon name="arrow-left"/> -->
        <img src="../assets/images/images/left_qq.png" alt />
      </div>
      <div class="title f12">
        {{ topWord }}
      </div>
      <div class="has-login c-c f14">已登录</div>
    </div>
    <div class="content">
      <div class="wrap-textarea" v-if="currentTag != 0">
        <van-cell-group>
          <van-field
            v-model="message"
            type="textarea"
            placeholder="请留言（尽可能详细，含联系方式）"
            rows="7"
            autosize
          />
        </van-cell-group>
      </div>
      <div class="recruitment-form" v-if="currentTag == 0">
        <div v-if="currentTag == 0" class="recruitNotice">用人单位请按以下所有栏目完整详实填写，如有缺失根据新规将不予通过！如有发布问题可微信联系平台客服！</div>
        <div class="position-group" v-for="(item, index) in recruitmentForm.positions" :key="index">
          <div class="group-header">
            <span class="group-title">招聘组 {{ index + 1 }}</span>
            <van-button 
              v-if="recruitmentForm.positions.length > 1" 
              type="danger" 
              size="mini" 
              plain
              @click="removePosition(index)"
            >删除</van-button>
          </div>
          <van-cell-group>
            <van-field
              v-model="item.position"
              placeholder="请输入岗位/工种名称"
            >
              <template #label>
                <span style="color: red">*</span><span style="color:#000">招聘岗位</span>
              </template>
            </van-field>
            <van-field
              v-model="item.count"
              type="number"
              placeholder="请输入招聘人数"
            >
              <template #label>
                <span style="color: red">*</span><span style="color:#000">招聘人数</span>
              </template>
            </van-field>
            <van-field
              :value="getSalaryText(item.salary)"
              placeholder="请选择工资待遇"
              readonly
              is-link
              @click="showSalaryPicker(index)"
            >
              <template #label>
                <span style="color: red">*</span><span style="color:#000">工资待遇</span>
              </template>
            </van-field>
            <van-field
              v-model="item.description"
              type="textarea"
              placeholder="请描述工作具体内容"
              rows="3"
              maxlength="300"
              show-word-limit
              autosize
            >
              <template #label>
                <span style="color: red">*</span><span style="color:#000">工作内容</span>
              </template>
            </van-field>
            <van-field
              v-model="item.requirements"
              type="textarea"
              placeholder="如：经验不限，学历不限"
              rows="3"
              maxlength="300"
              show-word-limit
              autosize
            >
              <template #label>
                <span style="color: red">*</span><span style="color:#000">招聘条件</span>
              </template>
            </van-field>
          </van-cell-group>
        </div>
        <van-button 
          v-if="recruitmentForm.positions.length < 3" 
          type="primary" 
          size="small" 
          @click="addPosition"
          style="margin: 10px 0"
        >+ 新增招聘组（限3组岗位）</van-button>
        <van-cell-group>
          <van-field
            v-model="recruitmentForm.companyName"
            placeholder="营业执照上公司名全称（必填）"
            @blur="validateCompanyName"
          >
            <template #label>
              <span style="color: red">*</span><span style="color:#000">公司名称</span>
            </template>
          </van-field>
          <van-field
            v-model="recruitmentForm.companyAddress"
            placeholder="请输入工作地址"
          >
            <template #label>
              <span style="color: red">*</span><span style="color:#000">工作地址</span>
            </template>
          </van-field>
          <van-field
            v-model="recruitmentForm.contact"
            placeholder="请输入联系人（如：李经理、张总）"
          >
            <template #label>
              <span style="color: red">*</span><span style="color:#000">联系人</span>
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div class="upload-file-div t-l">
        <div class="f15" style="margin-bottom: 3px">图片上传（最多9张）</div>
        <div class="c-p" style="flex-wrap: wrap">
          <template v-if="preShowIds.length != 0">
            <div
              @click="removePics(index)"
              class="wrap-load sia c-c"
              v-for="(item, index) in preShowIds"
              :key="index"
            >
              <van-icon name="close" class="sia-close" />
              <img :src="item" alt />
            </div>
          </template>
          <div
            class="wrap-load c-c"
            style="margin: 0px 0 0 0px"
            @click="chooseImages"
          >
            <div>
              <img src="../assets/images/images/Add.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="get-user-phone c-l">
        <div class="phone_input"><span style="color: red">*</span>确认联系号码：</div>
        <van-cell-group :border="border">
          <van-field
            ref="userInputPhone"
            @blur="checkUserInput"
            v-model="userPhone"
            placeholder="限填单个手机号"
          />
        </van-cell-group>
      </div>
      <!-- 标签部分 一级 -->
      <div class="tags c-c f-d-c">
        <div class="flex1 c-start one" style="flex-wrap: wrap">
          <div
            class="tags-one f12 c-c"
            :class="currentTag == index ? 'tags-one-active' : ''"
            v-for="(item, index) in list1"
            :key="index"
            @click="add(index)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <!-- 标签部分 二级 -->
      <div class="tags c-c f-d-c" v-if="showSecondTag">
        <div class="flex1 c-start one" style="flex-wrap: wrap">
          <div
            class="tags-one f12 c-c"
            :class="currentTag2 == index ? 'tags-one-active' : ''"
            v-for="(item, index) in list2"
            :key="index"
            @click="add2(index)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div v-if="currentTag == 5">
        <van-field required v-model="fromPlace" label="出发地：" placeholder="请输入出发地"/>
        <van-field required v-model="toPlace" label="目的地：" placeholder="请输入目的地"/>
        <van-field required v-model="facheTime" readonly @click-input="showPickTime = true" @click="showPickTime = true" right-icon="arrow" label="出发时间：" placeholder="请输入出发时间"/>
      </div>
      <div class="check-tag">
        <van-checkbox
          :disabled="!showTBMSg"
          v-model="checkedShop"
          shape="square"
          checked-color="#892785"
          >同步到我的店铺</van-checkbox
        >
      </div>
      <!-- 标签 -->
      <div class="c-start check-tag f10 c-c">
        <div
          @click="readRule()"
          :class="checked == true ? 'correct-a' : 'correct-b'"
        >
          <img src="../assets/images/images/correct_w.png" alt v-if="checked" />
        </div>
        <div style="margin-left: 10px">
          <span style="color: grey">我已阅读并同意</span>
        </div>
        <div @click="know" style="color: rgb(137, 39, 133)">《发布须知》</div>
        <div style="margin-left: 10px">
          <span style="color: grey">保证信息真实有效</span>
        </div>
      </div>
      <div class="sure-submit c-c">
        <div @click="sure()" class="sure-submit-btn f19 c-c">确认提交</div>
      </div>

      <van-action-sheet :close-on-click-overlay="false" :title="text" :closeable="currentTag==-1?false:true" v-model="show" @close="handleActionSheetClose">
        <div
          class="tag-err van-hairline--bottom"
          @click="chooseTagLevelOne(index)"
          v-for="(item, index) in actions"
          :key="index"
        >
          {{ item.title }}
        </div>
      </van-action-sheet>
      <van-popup class="reset-pop" v-model="showTips">
        <div v-html="tips.content"></div>
      </van-popup>
      <div
        v-show="showLoadingPic"
        style="
          z-index: 99;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: #000;
          opacity: 0.6;
        "
      >
        <div
          style="
            z-index: 100;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 50%;
            height: 50%;
          "
        >
          <van-loading size="24px" vertical color="rgb(137, 39, 133)"
            >图片上传中...</van-loading
          >
        </div>
      </div>
      <div
        @click="closeTips"
        v-if="showTips"
        style="
          z-index: 9999;
          margin: 0 auto;
          position: fixed;
          bottom: 5%;
          left: 0;
          right: 0;
          width: 30px;
          height: 30px;
        "
      >
        <img src="../assets/images/images/close.png" alt />
      </div>
      <br />
    </div>
    <van-popup v-model="showPickTime" position="bottom">
      <van-datetime-picker
        @confirm="pickTimeConfirm"
        @cancel="showPickTime = false"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="beginTime"
        type="datetime"
        title="选择出发时间"
      />
    </van-popup>
    <van-popup v-model="showSalaryPickerPopup" position="bottom" :safe-area-inset-bottom="true">
      <div class="salary-picker-container">
        <div class="salary-picker-header">
          <van-button type="default" size="small" @click="cancelSalaryPicker">取消</van-button>
          <span class="salary-picker-title">选择薪资范围（元/月）</span>
          <van-button type="primary" size="small" @click="confirmSalaryPicker">确定</van-button>
        </div>
        <div class="salary-picker-content">
          <div class="salary-picker-item">
            <div class="salary-picker-label">最低工资</div>
            <van-picker
              default-index="8"
              :columns="salaryOptions"
              v-model="currentSalaryMin"
              @change="onSalaryMinChange"
            />
          </div>
          <div class="salary-picker-item">
            <div class="salary-picker-label">最高工资</div>
            <van-picker
              default-index="26"
              :columns="salaryOptions"
              v-model="currentSalaryMax"
              @change="onSalaryMaxChange"
            />
          </div>
        </div>
        <div class="salary-piecework">
          <van-checkbox v-model="currentPiecework" checked-color="#882784" >计件（额外备注）</van-checkbox>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
let me;
let beforeUrl = "";
import { ActionSheet } from "vant";
import axios from "axios";
import lrz from "lrz";
import { getData } from "../Interface/http.js";
import { postData } from "../Interface/http.js";
import { apiUrl } from "../Interface/http.js";

export default {
  name: "PostMessage",
  data() {
    return {
      fromPlace: '',
      toPlace: '',
      minDate: new Date(),
      maxDate: new Date(2030, 1, 1),
      beginTime: '',
      facheTime: '',
      showPickTime: false,
      checkedShop: false,
      showLoadingPic: false,
      text: "",
      showTips: false,
      actions: [],
      show: false,
      imageList: [],
      imageListShow: [],
      imageListLimit: [],
      a: "",
      tips: "",
      loginStatus: 1,
      value: "",
      userPhone: "",
      message: "",
      border: false,
      list1: [],
      list2: [],
      currentTag: -1,
      currentTag2: -1,
      realTag: -1,
      checked: true,
      // 是否上传图片
      uploadPic: false,
      showSecondTag: false,
      imgForUpList: [],
      //xhy
      localIds: [], //chooseImage返回的本地图片id,
      preShowIds: [], //预览图片地址
      serverIds: [], //uploadImage返回的服务器图片id
      showTBMSg: false, //是否展示同步到店铺
      userInfoData: "",
      topWord: "", //顶部提示信息
      loading: false,
      // 工资选择器
      showSalaryPickerPopup: false,
      salaryOptions: [],
      currentSalaryMin: [],
      currentSalaryMax: [],
      currentSalaryIndex: 0,
      currentPiecework: false,
      // 招聘表单数据
      recruitmentForm: {
        positions: [
          {
            position: "",
            count: "",
            salary: { min: "", max: "", piecework: false },
            description: "",
            requirements: ""
          }
        ],
        companyName: "",
        companyAddress: "",
        contact: ""
      }
    };
  },
  created() {},
  mounted() {
    me = this;
    let token = localStorage.getItem("token");
    if (!token) {
      getData("/oauth/redirect/wechat").then((res) => {
        localStorage.setItem("startPage", "postMessage");
        window.location.href = res.data.redirect_url;
      });
    }
    me.getUserInfo();
    this.getTags();
    me.getConfigData();
    this.initSalaryOptions();
    if (
      localStorage.getItem("token") == null ||
      localStorage.getItem("token") == "123456"
    ) {
      this.loginStatus = 1;
    } else {
      this.loginStatus = 0;
    }
    me.getTopWord(); //获取顶部文案
  },
  beforeRouteEnter(to, from, next) {
    beforeUrl = from.fullPath;
    next();
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      if (type === 'hour') {
        return val + '时';
      }
      if (type === 'minute') {
        return val + '分';
      }
      return val;
    },
    pickTimeConfirm(value) {
      this.facheTime = value.toLocaleString();
      this.showPickTime = false
    },
    //获取顶部提示文案
    getTopWord() {
      let me = this;
      getData("/article/agreement?option_id=5", {
        token:
          localStorage.getItem("token") != ""
            ? localStorage.getItem("token")
            : "123456",
      })
        .then((res) => {
          me.topWord = res.data.content;
        })
        .catch((err) => {});
    },
    getUserInfo() {
      getData("/user/info", {
        token:
          localStorage.getItem("token") != ""
            ? localStorage.getItem("token")
            : "123456",
      })
        .then((res) => {
          if (res.code == 0) {
            me.userInfoData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dataURLtoFile(dataurl, filename) {
      //3.base64转文件
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    async getTrueImageA(datas) {
      //2.调用wx.getLocalImgData获取展示图片链接地址
      me.showLoadingPic = true;
      await wx.getLocalImgData({
        localId: datas[0],
        success: function (res) {
          var localData = res.localData;
          if (localData.indexOf("data:image") != 0) {
            //判断是否有这样的头部
            localData = "data:image/jpeg;base64," + localData;
          }
          localData = localData
            .replace(/\r|\n/g, "")
            .replace("data:image/jgp", "data:image/jpeg");
          me.preShowIds.push(localData);
          let date = Date.parse(new Date());
          let a = me.dataURLtoFile(localData, date);
          me.onRead(a, datas);
        },
        fail: function (err) {},
      });
    },

    readRule() {
      this.checked = !this.checked;
    },
    closeTips() {
      this.showTips = false;
    },
    chooseImages() {
      //1.调用wx.chooseImage选择图片
      let canChooseImgNum = 9 - me.localIds.length;
      if (canChooseImgNum <= 0) {
        this.$toast("图片最多只能上传9张哦~");
        return;
      }
      wx.chooseImage({
          count: canChooseImgNum,
          success: function (res) {
            me.localIds.push(...res.localIds);
            me.getTrueImageA(res.localIds, "test");
          },
          fail: function (err) {
            console.log(err);
          },
        });
    },
    getConfigData() {
      //获取配置数据
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var iPad = u.indexOf("iPad") > -1;
      var iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
      let anURL =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        window.location.search; //安卓地址
      let iosURL = this.$store.state.jumpUrl; //ios地址
        
      let result = "";
      if (isAndroid) {
        result = anURL;
      }
      if (isiOS || iPad || iPhone) {
        result = iosURL;
      }
      //this.message=result;
      result = encodeURIComponent(result);
      getData("/oauth/credential/jssdk?debug=1&url=" + result).then((res) => {
        wx.config({
            beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名，见附录1
            jsApiList: ["chooseImage", "uploadImage"], // 必填，需要使用的JS接口列表，所有JS接口列表见微信公众平台附录
          });      
      }).catch(err => {
        alert('错误');
      })
    },
    removePics(index) {
      //移除图片
      this.localIds.splice(index, 1);
      this.preShowIds.splice(index, 1);
      this.serverIds.splice(index, 1);
      if (me.currentTag != "-1" && me.currentTag2 == "-1") {
        me.add(me.currentTag);
      }
      if (me.currentTag != "-1" && me.currentTag2 != "-1") {
        me.add2(me.currentTag2);
      }
    },
    checkUserInput() {
      let regBox = {
        regEmail: /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/, //邮箱
        regName: /^[a-z0-9_-]{3,16}$/, //用户名
        regMobile: /^1[3-9]\d{9}$/, //手机
        regTel: /^0[\d]{2,3}-[\d]{7,8}$/,
      };
      let mflag = regBox.regMobile.test(this.userPhone);
      if (!mflag) {
        this.$toast("手机号有误！如：1875***9867");
      }
    },
    getTags() {
      getData("/categories").then((res) => {
        this.list1 = res.data;
        this.list2 = res.data[9].children;
        if (this.currentTag === -1) {
          this.text = "请选择一级标签";
          this.actions = this.list1;
          this.show = true;
        }
      });
    },
    onRead(file, datas) {
      //4.上传用户选中的图片
      let formData = new FormData();
      formData.append("thumb", file);
      let url = "";
      url = "http://api.jfc.jfbst.com/api/v2/upload";
      axios({
        url: url,
        processData: false, // 告诉axios不要去处理发送的数据(重要参数)
        contentType: false, // 告诉axios不要去设置Content-Type请求头
        method: "post",
        data: formData,
      }).then((res) => {
        me.showLoadingPic = false;
        this.serverIds.push(res.data.data.src);
        if (me.localIds.length > 0) {
          if (me.currentTag != "-1" && me.currentTag2 == "-1") {
            me.add(me.currentTag);
          }
          if (me.currentTag != "-1" && me.currentTag2 != "-1") {
            me.add2(me.currentTag2);
          }
        }
        let aa = datas;
        aa.shift();
        if (aa.length > 0) {
          me.getTrueImageA(aa);
        }
      });
    },
    add(index) {
      this.checkedShop = false;
      this.currentTag = index;
      this.currentTag2 = "-1";
      if(index != 0) {
        this.resetRecruitmentForm();
      }
      if (this.list1[this.currentTag].children && this.list1[this.currentTag].children.length > 0) {
        this.list2 = this.list1[this.currentTag].children;
        this.showSecondTag = true;
      } else {
        this.list2 = [];
        this.showSecondTag = false;
        this.realTag = this.list1[this.currentTag].id;
      }
      if (!me.userInfoData.shop_status || me.preShowIds.length < 1) {
        this.showTBMSg = false;
        return;
      }
      if (this.list1[this.currentTag].is_sync == 1) {
        //如果接口返回能同步就同步
        this.showTBMSg = true;
      } else {
        this.showTBMSg = false;
      }
    },
    add2(index) {
      this.checkedShop = false;
      this.currentTag2 = index;
      this.realTag = this.list2[this.currentTag2].id;
      if (!me.userInfoData.shop_status || me.preShowIds.length < 1) {
        this.showTBMSg = false;
        return;
      }
      if (this.list2[this.currentTag2].is_sync == 1) {
        //如果接口返回能同步就同步
        this.showTBMSg = true;
      } else {
        this.showTBMSg = false;
      }
    },
    chooseTagLevelOne(index) {
      this.show = false;
      if (this.currentTag == -1) {
        this.currentTag = index;
        this.resetRecruitmentForm();
        if (this.list1[this.currentTag].children && this.list1[this.currentTag].children.length > 0) {
          this.list2 = this.list1[this.currentTag].children;
          this.showSecondTag = true;
          this.realTag = -1;
        } else {
          this.realTag = this.list1[this.currentTag].id;
          this.showSecondTag = false;
        }


        //校验是否可以同步店铺
        if (!this.userInfoData.shop_status || this.preShowIds.length < 1) {
          this.showTBMSg = false;
          return;
        }
        if (this.list1[this.currentTag].is_sync == 1) {
          //如果接口返回能同步就同步
          this.showTBMSg = true;
        } else {
          this.showTBMSg = false;
        }
      } else {
        this.currentTag2 = index;
        this.realTag = this.list2[this.currentTag2].id;


        //校验是否可以同步店铺
        if (!this.userInfoData.shop_status || this.preShowIds.length < 1) {
          this.showTBMSg = false;
          return;
        }
        if (this.list2[this.currentTag2].is_sync == 1) {
          //如果接口返回能同步就同步
          this.showTBMSg = true;
        } else {
          this.showTBMSg = false;
        }
      }
    },
    onSelect(item) {
      this.show = false;
    },
    handleActionSheetClose() {
      if (this.currentTag === -1) {
        this.$toast("请选择一级分类");
        this.show = true;
      }
    },
    addPosition() {
      if (this.recruitmentForm.positions.length < 3) {
        this.recruitmentForm.positions.push({
          position: "",
          count: "",
          salary: "",
          description: ""
        });
      }
    },
    removePosition(index) {
      if (this.recruitmentForm.positions.length > 1) {
        this.recruitmentForm.positions.splice(index, 1);
      }
    },
    resetRecruitmentForm() {
      this.recruitmentForm = {
        positions: [
          {
            position: "",
            count: "",
            salary: { min: "", max: "", piecework: false },
            description: "",
            requirements: ""
          }
        ],
        companyName: "",
        companyAddress: "",
        contact: ""
      };
    },
    assembleRecruitmentMessage() {
      let message = "";
      this.recruitmentForm.positions.forEach((item, index) => {
        message += `招聘岗位：${item.position}\n`;
        message += `招聘人数：${item.count}\n`;
        message += `工资待遇：${this.getSalaryText(item.salary)}\n`;
        message += `工作内容：${item.description}\n`;
        message += `招聘条件：${item.requirements}\n`;
        if (index < this.recruitmentForm.positions.length - 1) {
          message += "\n";
        }
      });
      message += `\n公司名称：${this.recruitmentForm.companyName}\n`;
      message += `工作地址：${this.recruitmentForm.companyAddress}\n`;
      message += `联系人：${this.recruitmentForm.contact}\n`;
      message += `联系电话：${this.userPhone}\n信息有效期：30天`;
      return message;
    },
    cat() {
      this.$store.commit("UPDATEATBINDEX", { tag: 0 });
      this.$router.push({
        name: "home",
      });
    },
    getToken() {
      getData("/oauth/redirect/wechat").then((res) => {
        window.location.href = res.data.redirect_url;
      });
    },

    cat2() {
      this.$store.commit("UPDATEATBINDEX", { tag: 0 });
      this.$router.push({
        name: "home",
      });
    },
    sure() {
      if(this.loading) {
        return;
      }
      if (this.currentTag == 0) {
        for (let i = 0; i < this.recruitmentForm.positions.length; i++) {
          const pos = this.recruitmentForm.positions[i];
          if (!pos.position) {
            this.$toast(`岗位${i + 1}：请输入招聘岗位`);
            return;
          }
          if (!pos.count) {
            this.$toast(`岗位${i + 1}：请输入招聘人数`);
            return;
          }
          if (!pos.salary.min && !pos.salary.max) {
            this.$toast(`岗位${i + 1}：请选择工资待遇`);
            return;
          }
          if (!pos.description) {
            this.$toast(`岗位${i + 1}：请输入工作内容`);
            return;
          }
          if (!pos.requirements) {
            this.$toast(`岗位${i + 1}：请输入招聘条件`);
            return;
          }
        }
        if (!this.recruitmentForm.companyName) {
          this.$toast("请输入公司名称");
          return;
        }
        if (this.recruitmentForm.companyName.length < 8) {
          this.$toast("根据新规，公司名需按营业执照上的全称填写！");
          return;
        }
        if (!this.recruitmentForm.companyAddress) {
          this.$toast("请输入工作地址");
          return;
        }
        if (!this.recruitmentForm.contact) {
          this.$toast("请输入联系人");
          return;
        }
        this.message = this.assembleRecruitmentMessage();
      } else {
        if (this.message == "") {
          this.$toast("输入发布内容");
          return;
        }
      }
      if (!this.userPhone) {
        this.$toast("请输入联系电话");
        return;
      }
      if (this.currentTag == -1) {
        this.text = "请选择一级标签";
        this.actions = this.list1;
        this.show = true;
        return;
      } else if (this.list1[this.currentTag].children && this.list1[this.currentTag].children.length > 0 && this.currentTag2 == -1) {
        // this.$toast.fail("请选择二级标签");
        this.text = "请选择二级标签";
        this.actions = this.list2;
        this.show = true;
        return;
      } else if (this.checked == false) {
        this.$toast("请先勾选同意《发布须知》");
      } else if (this.loginStatus == 1) {
        this.$toast("请先登录系统");
      } else if(this.currentTag == 5 && (!this.fromPlace||!this.toPlace||!this.facheTime)){
        if(!this.fromPlace){
          this.$toast("请输入出发地");
          return;
        }
        if(!this.toPlace){
          this.$toast("请输入目的地");
          return;
        }
        if(!this.facheTime){
          this.$toast("请选择出发时间");
          return;
        }
      } else {
        this.loading = true;
        this.postArticle();
      }
    },
    login() {
      getData("/oauth/redirect/wechat").then((res) => {
        localStorage.setItem("startPage", "postMessage");
        window.location.href = res.data.redirect_url;
      });
    },
    postArticle() {
      let param = {};
      let formData = new FormData();
      for (let a = 0; a < this.serverIds.length; a++) {
        formData.append("thumb[]", this.serverIds[a]);
      }
      //checkedShop
      formData.append("category", this.realTag);
      formData.append("phone", this.userPhone);
      formData.append("sync", this.checkedShop ? 1 : 0);
      formData.append("sync_index", this.checkedHome ? 1 : 0);
      if(this.currentTag == 5) {
        let title = this.list2[this.currentTag2].title;
        formData.append("content", title+'\n' + '出发地：' + this.fromPlace + '\n' + '目的地：' + this.toPlace + '\n' + '出发时间：' + this.facheTime +'\n\n' + this.message);
      } else {
        formData.append("content", this.message);
      }
      postData("/publish-message", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token:
            localStorage.getItem("token") != ""
              ? localStorage.getItem("token")
              : "123456",
        },
      })
        .then((res) => {
          this.data = {
            fromPlace: '',
            toPlace: '',
            beginTime: '',
            facheTime: '',
            checkedShop: false,
            showLoadingPic: false,
            text: "",
            showTips: false,
            actions: [],
            show: false,
            imageList: [],
            imageListShow: [],
            imageListLimit: [],
            a: "",
            tips: "",
            loginStatus: 1,
            value: "",
            userPhone: "",
            message: "",
            border: false,
            list1: [],
            list2: [],
            currentTag: -1,
            currentTag2: -1,
            realTag: -1,
            checked: true,
            // 是否上传图片
            uploadPic: false,
            showSecondTag: false,
            imgForUpList: [],
            localIds: [], 
            preShowIds: [], //预览图片地址
            serverIds: [], //uploadImage返回的服务器图片id
            showTBMSg: false, //是否展示同步到店铺
            recruitmentForm: {
              positions: [
                {
                  position: "",
                  count: "",
                  salary: { min: "", max: "", piecework: false },
                  description: "",
                  requirements: ""
                }
              ],
              companyName: "",
              companyAddress: "",
              contact: ""
            }
          };
          this.loading = false;
          this.$router.push({
            name: "postSuc",
          });
        })
        .catch((err) => {
          this.loading = false;
          this.$toast("发布失败");
        });
    },
    know() {
      getData("/article/agreement?option_id=3").then((res) => {
        this.tips = res.data;
        this.showTips = true;
      });
    },
    initSalaryOptions() {
      const options = [];
      for (let i = 2000; i <= 30000; i += 500) {
        options.push(i.toString());
      }
      this.salaryOptions = options;
    },
    getSalaryText(salary) {
      let text = "";
      if (salary.min && salary.max) {
        if(salary.min == salary.max) {
          text = `${salary.min}`;
        } else {
          text = `${salary.min}-${salary.max}`;
        }
      } else if (salary.min) {
        text = `${salary.min}以上`;
      } else if (salary.max) {
        text = `${salary.max}以下`;
      }
      if (salary.piecework) {
        text += "（计件）";
      }
      return text;
    },
    showSalaryPicker(index) {
      this.currentSalaryIndex = index;
      const salary = this.recruitmentForm.positions[index].salary;
      this.currentSalaryMin = salary.min ? [salary.min] : ["6000"];
      this.currentSalaryMax = salary.max ? [salary.max] : ["15000"];
      this.currentPiecework = salary.piecework || false;
      this.showSalaryPickerPopup = true;
    },
    cancelSalaryPicker() {
      this.showSalaryPickerPopup = false;
    },
    confirmSalaryPicker() {
      const min = this.currentSalaryMin.length > 0 ? this.currentSalaryMin[0] : "";
      const max = this.currentSalaryMax.length > 0 ? this.currentSalaryMax[0] : "";
      console.log(min, max);
      
      if (min && max && parseInt(min) > parseInt(max)) {
        this.$toast("最低工资不能大于最高工资");
        return;
      }
      
      this.recruitmentForm.positions[this.currentSalaryIndex].salary = {
        min: min,
        max: max,
        piecework: this.currentPiecework
      };
      this.showSalaryPickerPopup = false;
    },
    onSalaryMinChange(picker, value, index) {
      this.currentSalaryMin = [value];
    },
    onSalaryMaxChange(picker, value, index) {
      this.currentSalaryMax = [value];
    },
    validateCompanyName() {
      if (this.recruitmentForm.companyName && this.recruitmentForm.companyName.length < 8) {
        this.$toast("根据新规，公司名需按营业执照上的全称填写！");
      }
    },
  },
};
</script>

<style scoped>
::v-deep .van-field--disabled .van-field__label {
  color: #646566;
}
.reset-pop {
  width: 80%;
  max-height: 70% !important;
  border-radius: 3px;
  padding: 10px;
}
.position-group {
  margin-bottom: 10px;
}
.group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 5px 10px;
  box-sizing: border-box;
}
.phone_input {
  line-height: 21px;
}
.group-title {
  font-weight: bold;
}
.recruitNotice{
  padding: 5px 10px 0 10px;
  box-sizing: border-box;
  background-color: #ffffff;
  color: #882784;
  font-size: 13px;
  line-height: 20px;
}
::v-deep .van-field__control::placeholder {
  font-size: 14px;
}

::v-deep .van-field__control--custom::placeholder {
  font-size: 14px;
}
.sia {
  position: relative;
}
.sia-close {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 7px;
  background: #fff;
  border-radius: 50%;
}
.post-message {
  /* padding: 0 14px; */
  box-sizing: border-box;
  background: rgb(232, 232, 232);
  min-height: 100vh;
}
.head-nav {
  min-height: 42px;
  width: 100%;
  padding: 5px 3px;
  box-sizing: border-box;
  background: rgb(232, 232, 232);
}
.head-nav .left-aaaa {
  width: 20px;
  height: 18px;
  margin-left: 5px;
}
.title {
  color: rgb(143, 143, 143);
  width: 250px;
  text-align: left;
  /* height: 52px; */
}
.login {
  color: #fff;
  background: rgb(137, 39, 133);
  width: 48px;
  height: 26px;
  border-radius: 4px;
  margin-right: 13px;
}
.has-login {
  color: #fff;
  background: rgb(169, 169, 169);
  width: 48px;
  height: 26px;
  border-radius: 4px;
  margin-right: 13px;
}
.field {
  height: 120px;
}
.field input {
  height: 110px;
}
.mes {
  width: 90%;
  height: 117px;
}
.content {
  /* padding: 13px; */
  box-sizing: border-box;
}
.wrap-textarea {
  width: 100%;
  background: #fff;
  padding: 13px;
  box-sizing: border-box;
}
.upload-file-div {
  background: #fff;
  padding: 13px;
  box-sizing: border-box;
}
.wrap-load {
  width: 59px;
  height: 59px;
  border: 1px dashed rgb(220, 220, 220);
  margin-right: 5px;
}
.wrap-load i {
  font-size: 23px;
  color: rgb(220, 220, 220);
}
.get-user-phone {
  padding: 0 13px;
  box-sizing: border-box;
  background: #fff;
}
.tags {
  padding: 10px 10px;
  box-sizing: border-box;
  background: #fff;
  margin-top: 7px;
}
.tags-one {
  width: 78px;
  height: 33px;
  color: rgb(196, 196, 196);
  margin: 0 5px 7px 5px;
  border-radius: 3px;
  border: 1px solid #bdbdbd;
  box-sizing: border-box;
}
.tags-one-active {
  color: rgb(137, 39, 133) !important;
  border: solid 1px rgb(137, 39, 133);
  border-radius: 3px;
  box-sizing: border-box;
}
.tags .one,
.tags .second {
  width: 100%;
}
.tags .second {
  margin: 7px 0 0 0;
}
.check-tag {
  padding: 9px 0 9px 24px;
  box-sizing: border-box;
  /* background: #fff; */
  
}
.sure-submit {
  /* background: #fff; */
}
.sure-submit-btn {
  background: rgb(137, 39, 133);
  color: #fff;
  width: 332px;
  height: 41px;
  border-radius: 5px;
}
.tag-err {
  line-height: 2.5rem;
}
.correct-a {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgb(137, 39, 133);
}
.correct-a img {
  width: 80%;
}
.correct-b {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e8e8e8;
  border: solid 1px rgb(137, 39, 133);
  box-sizing: border-box;
}
.correct-b img {
  width: 80%;
}
.salary-picker-container {
  background: #fff;
}
.salary-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #ebedf0;
}
.salary-picker-title {
  font-size: 16px;
  font-weight: 500;
}
.salary-picker-content {
  display: flex;
}
.salary-picker-item {
  flex: 1;
}
.salary-picker-label {
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  color: #646566;
  background: #f7f8fa;
}
.salary-piecework {
  padding: 10px 16px;
  background: #fff;
}
</style>
